export default "__VITE_ASSET__DYGWnFnI__"